<template>
	<section v-if="footerSection.image" class="pre-footer">
		<div class="row small-row">
			<div v-if="footerSection.content" class="columns column4 align-left">
				<h2>{{ footerSection.header }}</h2>
				<div v-parse-links v-html="footerSection.content" />
			</div>
		</div>
		<picture>
			<source v-if="footerSection.imageWebp" :srcset="footerSection.imageWebp" type="image/webp" />
			<source :srcset="footerSection.image" />
			<img :src="footerSection.image" class="bg-image" loading="lazy" :alt="footerSection.imageAlt" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	footerSection: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.pre-footer {
	position: relative;
	border-top: 14px solid var(--primary-background-color);
	border-bottom: 14px solid var(--primary-background-color);
	min-height: 500px;

	.column4 {
		margin: 50px 0;
		color: #fff;
		backdrop-filter: blur(34px);
		background: rgb(15 55 85 / 70%);
		padding: 65px 45px;
		position: relative;
		z-index: 2;

		h2,
		:deep(h2) {
			color: #fff;
		}
	}
}

.bg-image {
	position: absolute;
	inset: 0;
	height: 100%;
	width: 100%;
	object-fit: cover;
	z-index: 1;
}

@media (max-width: 900px) {
	.pre-footer {
		.column4 {
			width: 58%;
		}
	}
}

@media (max-width: 600px) {
	.pre-footer {
		.column4 {
			width: 82%;
			margin: 120px auto;
		}
	}
}
</style>
